import { find as _find, isObject as _isObject, map as _map } from 'lodash';

const reward = 20;

const state = {
  pickedQuestions: [], // Which question has been picked by which player 0:1 -> 1st question has been picked by the second player (zero based)
  state: 0 // 0 = "picking", 1 = "mediaPlaying", 2 = "playing"
};

const actions = {
  startRound: ({ commit, getters, rootGetters }) => {
    commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
      root: true
    });
    commit('RESET_PICKED_QUESTIONS', getters.questions.length);
    commit('SHOW_ROUND_PLAYSCREEN', null, { root: true });
    commit('SHOW_PICKER_SCREEN');
  },
  startQuestion: () => {
    // console.log('START QUESTION')
  },
  startPlaying: ({ commit, dispatch }) => {
    return dispatch('startClockForActivePlayer', null, { root: true }).then(
      () => {
        commit('SHOW_PLAY_SCREEN');
      }
    );
  },
  pickQuestion: ({ commit }, { questionId, playerId }) => {
    commit('SET_CURRENT_QUESTION', questionId, { root: true });
    commit('END_PLAYER_FIRST_TURN', playerId, { root: true });
    commit('MARK_QUESTION_AS_PICKED', questionId);
    commit('SHOW_VIDEO_SCREEN');
  },
  nextQuestion: ({ dispatch, commit, rootGetters }) => {
    if (rootGetters.nextPlayerToStartAQuestion) {
      commit('DISABLE_REVIEW_MODE', null, { root: true });
      commit('RESET_ALL_PLAYERS_TURNS', null, { root: true });
      commit('RESET_FOUND_KEYWORDS', null, { root: true });
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerToStartAQuestion.id, {
        root: true
      });
      commit('SHOW_PICKER_SCREEN');
    } else {
      dispatch('nextRound', null, { root: true });
    }
  },
  answerQuestion: ({ commit, getters, dispatch, rootGetters }, keywordId) => {
    const playerId = rootGetters.activePlayer.id;
    commit('REWARD_PLAYER', { playerId, score: reward }, { root: true });
    commit('MARK_KEYWORD_AS_FOUND', { keywordId, playerId }, { root: true });
    if (getters.allKeywordsAreFound) {
      dispatch('stopClock');
    }
  },
  stopClock: ({ dispatch, commit, getters, rootGetters }) => {
    commit('STOP_CLOCK', null, { root: true });
    dispatch('endActivePlayerTurn', null, { root: true });
    if (!getters.allKeywordsAreFound && rootGetters.nextPlayerByLowestScore) {
      commit('ACTIVATE_PLAYER', rootGetters.nextPlayerByLowestScore.id, {
        root: true
      });
    } else {
      dispatch('enableReviewMode', null, { root: true });
    }
  }
};

const mutations = {
  RESET_PICKED_QUESTIONS: state => {
    state.pickedQuestions = [];
  },
  MARK_QUESTION_AS_PICKED: (state, questionId) => {
    state.pickedQuestions.push(questionId);
  },
  SHOW_PICKER_SCREEN: state => {
    state.state = 0;
  },
  SHOW_VIDEO_SCREEN: state => {
    state.state = 1;
  },
  SHOW_PLAY_SCREEN: state => {
    state.state = 2;
  }
};

const getters = {
  questions(state, getters, rootState) {
    return rootState.questionsPerRound[1].questions;
  },
  activeQuestion(state, getters, rootState) {
    return getters.questions[rootState.game.currentQuestion];
  },
  activeKeywords(state, getters, rootState, rootGetters) {
    return getters.activeQuestion.keywords.map((keyword, keywordId) => {
      const foundKeyword = _find(
        rootState.game.foundKeywords,
        k => k.keywordId === keywordId
      );
      return {
        id: keywordId,
        name: keyword,
        found: _isObject(foundKeyword),
        foundBy: foundKeyword
          ? rootGetters.players[foundKeyword.playerId].name
          : false,
        score: reward
      };
    });
  },
  allKeywordsAreFound(state, getters, rootState) {
    return (
      rootState.game.foundKeywords.length ===
      getters.activeQuestion.keywords.length
    );
  },
  preloadImgUrls(state, getters) {
    return _map(getters.questions, 'thumbnail');
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
};
